import { PUSH_OPEN_ID } from '../constants/sidebar';

const initialState = {
  openedIds: null,
};

export default function fetchReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PUSH_OPEN_ID:
      return Object.assign({}, state, {
        openedIds: payload !== state.openedIds ? payload : null,
      });
    default:
      return state;
  }
}
